module.exports = {"title":"Sorry!","contentCant":"This transaction can't be refunded.","contentAlready":"This transaction has already been refunded.","ok":"Ok"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Search/RefundErrorModal/locales/en.json
// module id = 1446
// module chunks = 0